import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SkyAutocompleteModule } from '../autocomplete';
import { SkyTokensModule } from '../tokens';

import { SkyLookupComponent } from './lookup.component';


export class SkyLookupModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyLookupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SkyAutocompleteModule,
    SkyTokensModule
  ],
  exports: [
    SkyLookupComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
